/**
 * @fileOverview The main entry point to your standalone. Start editing here.
 */

import React, { useEffect, useState } from 'react'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/reset.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/site.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/segment.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/container.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/header.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/image.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/list.css'
import './styles.scss'
import { Heatmap } from 'components/heatmap'
import { MetaInfos } from 'components/MetaInfos'
import { Masthead } from '@ta-interaktiv/react-masthead'
import { Footer } from '@ta-interaktiv/react-footer'
import { ThemeSwitch } from '@ta-interaktiv/react-theme-switch'
import csvjson from 'csvjson'
import { groups } from 'd3-array'
import { Link } from '@ta-interaktiv/contentbricks'
import { SortToggle } from 'components/SortToggle'
import { ChartSettings } from 'components/ChartSettings'
import { parseHostname } from '@ta-interaktiv/parse-hostname'
import browsercheck from '@ta-interaktiv/browsercheck'

// TODO Set the correct article ID here
const ARTICLE_ID = '411154442055'

const getmax = (arr: weektype[], absolute: boolean) => {
  return Math.max.apply(
    null,
    arr.map(e => {
      return Math.max.apply(
        null,
        Object.entries(e)
          .filter(f => {
            if (!absolute) {
              if (f[0].includes('+') && !f[0].includes('_abs')) return f
            }
            if (absolute) {
              if (f[0].includes('+') && f[0].includes('_abs')) return f
            }
          })

          .map(m => +m[1])
      )
    })
  )
}

export function AppComponent() {
  const [isEmbeded, setEmbed] = useState<boolean>(
    new URL(window.location.toString()).searchParams.get('emb') === 'true'
      ? true
      : false
  )
  const [drawData, setDrawData] = useState<formated_data>()
  const [showAll, setShowAll] = useState<boolean>(false)
  const [showAbsolute, setShowAbsolute] = useState<boolean>(false)
  const [reversedColors, setReversedColors] = useState<boolean>(false)
  const [unifiedScale, setUnifiedScale] = useState<boolean>(false)
  useEffect(() => {
    fetch(
      'https://storage.googleapis.com/ta-interaktiv/corona-dashboard/byage.csv?a=' +
        Math.random()
    )
      .then(response => {
        return response.text()
      })
      .then(csv => {
        let data = csvjson.toObject(csv, {}).map(d => {
          Object.keys(d).forEach(k => {
            if (k !== 'canton') d[k] = +d[k]
          })
          return d
        })
        let dd: { [key: string]: weektype[] } = {}
        Array.from(groups(data, d => d.canton)).forEach(d => (dd[d[0]] = d[1]))
        console.log(dd)

        setDrawData(dd)
      })
  }, [])

  useEffect(() => {
    setShowAll(showAll)
  }, [showAbsolute, showAll, reversedColors, unifiedScale])

  const unifiedMax = showAbsolute ? 1000 : 300
  const firstDate = new Date('2021-03-01')
  const secondDate = new Date()
  const oneDay = 24 * 60 * 60 * 1000
  const weekSinceJune = Math.ceil(
    Math.round(Math.abs((+firstDate - +secondDate) / oneDay)) / 7
  )

  return (
    <div className='index'>
      <ThemeSwitch />
      {!isEmbeded && (
        <>
          <Masthead articleId={ARTICLE_ID} />
          <header className='ui vertical  very fitted  segment'>
            <div className='ui container'>
              <div className='ui header'>
                <h1>Jetzt stecken sich wieder vermehrt Ältere an</h1>
                <h2>
                  Lange sah es so aus, als könnten sich die älteren Generationen
                  vor einer Ansteckung mit Sars-Cov-2 schützen. Nun verbreitet
                  sich das Virus aber wieder stärker unter ihnen – mit tödlichen
                  Konsequenzen.
                </h2>
              </div>
            </div>
          </header>
          <div className='ui vertical segment'>
            <div className='ui text container'>
              <MetaInfos
                authors={['Marc Brupbacher', 'Sebastian Broschinski']}
                updated='Text 11. September, Grafiken werden wöchentlich aktualisiert'
              />
              <div className='ta text'>
                <p>
                  Der Grund für die aktuell tiefe Zahl an Corona-Todesfällen
                  liegt zum einen in der Altersstruktur der Infizierten und zum
                  anderen an der deutlich tieferen Zahl an Fällen im Vergleich
                  zum März und April. In den letzten Monaten haben sich vor
                  allem junge Menschen zwischen 20 und 30 Jahren angesteckt.
                  Weil das Alter einer der wichtigsten Risikofaktoren für einen
                  schweren Verlauf ist, gibt es dementsprechend wenig{' '}
                  <Link
                    href={
                      'https://interaktiv.' +
                      parseHostname().publicationDomain +
                      '/2020/covid-19-ausbruch-im-vergleich/'
                    }
                  >
                    Spitaleintritte.
                  </Link>
                </p>
                <p>
                  Nun aber zeigt sich, dass sich in den vergangenen Wochen
                  vermehrt auch wieder ältere Personen anstecken in der Schweiz.
                </p>
              </div>
            </div>
          </div>
        </>
      )}
      <div className='ui vertical very fitted segment'>
        <div className={'ui text container ' + (isEmbeded ? 'emb' : '')}>
          <div className='ta text'>
            <div className='charthead'>
              <ChartSettings embeded={isEmbeded}>
                <>
                  <SortToggle
                    labels={['Zeitraum', 'ab 1. März 2021', 'ab 24. Februar 2020']}
                    sort={showAll}
                    setSort={setShowAll}
                  />
                  {!isEmbeded && (
                    <SortToggle
                      labels={['Skalierung', 'Einzeln', 'Gesamt']}
                      sort={unifiedScale}
                      setSort={setUnifiedScale}
                    />
                  )}
                  <SortToggle
                    labels={['Daten', 'Inzidenz', 'Absolut']}
                    sort={showAbsolute}
                    setSort={setShowAbsolute}
                  />
                  <SortToggle
                    labels={['Farben', 'Normal', 'Umgekehrt']}
                    sort={reversedColors}
                    setSort={setReversedColors}
                  />
                </>
              </ChartSettings>

              <div className='chart title'>
                Verteilung der bestätigten Fälle nach Altersgruppen
              </div>
              <div className='chart subtitle'>
                {!showAbsolute &&
                  (browsercheck.isMobile
                    ? "Fälle pro 100'000 Personen, nach KW"
                    : "Fälle pro 100'000 Personen, nach Kalenderwoche")}

                {showAbsolute && 'Absolute Fallzahlen'}
              </div>
            </div>
          </div>
        </div>
        <div className={'ui  container ' + (isEmbeded ? 'emb' : '')}>
          {drawData &&
            ['CH'].map(code => {
              let ddd = showAll
                ? drawData[code]
                : drawData[code].slice(drawData[code].length - weekSinceJune)
              let max = unifiedScale
                ? unifiedMax
                : Math.ceil(getmax(ddd, showAbsolute) / 10) * 10
              return (
                <div className='graphwrapper'>
                  <Heatmap
                    data={ddd}
                    scalemax={max}
                    rechtheightmulti={2}
                    inverted={reversedColors}
                    absolute={showAbsolute}
                  />
                </div>
              )
            })}
        </div>
        {!isEmbeded && (
          <div className='ui text container'>
            <div className='chart reading'>
              <b>Lesebeispiel: </b>
              <br />
              In der Schweiz wurden in der Woche vom 31.8 bis 6.9 rund{' '}
              <span>14 Personen</span> in der <span>Altersgruppe 60-69</span>{' '}
              pro 100'000 <span>60-69-Jährige</span> positiv getestet.
            </div>
          </div>
        )}
      </div>{' '}
      {!isEmbeded && (
        <>
          <div className='ui vertical very fitted  segment'>
            <div className='ui text container'>
              {drawData &&
                [
                  'ZH',
                  'BE',
                  'LU',
                  'UR',
                  'SZ',
                  'OW',
                  'NW',
                  'GL',
                  'ZG',
                  'FR',
                  'SO',
                  'BS',
                  'BL',
                  'SH',
                  'AR',
                  'AI',
                  'SG',
                  'GR',
                  'AG',
                  'TG',
                  'TI',
                  'VD',
                  'VS',
                  'NE',
                  'GE',
                  'JU'
                ].map(code => {
                  let ddd = showAll
                    ? drawData[code]
                    : drawData[code].slice(drawData[code].length - 14)
                  let max = unifiedScale
                    ? unifiedMax
                    : Math.ceil(getmax(ddd, showAbsolute) / 10) * 10
                  return (
                    <div className='graphwrapper'>
                      <Heatmap
                        data={ddd}
                        scalemax={max}
                        inverted={reversedColors}
                        absolute={showAbsolute}
                      />
                    </div>
                  )
                })}
            </div>
          </div>

          <div className='ui vertical very fitted segment'>
            <Footer
              articleId={ARTICLE_ID}
              questions={[
                'Wie verständlich waren die Grafiken?',
                'Wie gefällt Ihnen die Gestaltung?'
              ]}
              credits={[
                [
                  'Konzept und Umsetzung',
                  'Marc Brupacher, Sebastian Broschinski'
                ],
                ['Quelle', 'Bundesamt für Gesundheit (BAG)']
              ]}
            />
          </div>
        </>
      )}
    </div>
  )
}
